import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950 font-heading">{featuresData.title}</h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base">{featuresData.subtitle}</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {featuresData.items.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70 hover:border-primary-200 transition-colors">
              <div className="w-11 h-11 flex items-center justify-center bg-primary-100 rounded-lg mb-4">
                <i className={`${item.icon} text-primary-500 text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}